import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getTranslation } from 'common/react/utils/translations';

export const MobileTableRoundHeaderRow = ({
    cssClass,
    rowData,
    activeColumn
}) => {
    return (
        <div className={`${cssClass}__body-row`}>
            <div className={`${cssClass}__row-header`}>
                {getTranslation('label.brownlow.predictor.round')}
            </div>

            {rowData.map((cell, cellIndex) => {
                return (
                    <div
                        className={`${cssClass}__round-header-cell`}
                        key={cellIndex}
                    >
                        <div
                            className={classnames('mobile-cell-wrapper', {
                                'is-current':
                                    activeColumn === 0 &&
                                    cell.column.Header === 'OR'
                                        ? true
                                        : cell.column.Header === activeColumn
                            })}
                        >
                            {cell.column.Header}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

MobileTableRoundHeaderRow.propTypes = {
    cssClass: PropTypes.string,
    rowData: PropTypes.array,
    activeColumn: PropTypes.number
};
